<template>
  <div class="centerx" id="customer-popup-content">
    <vs-popup
      class="customer-popup"
      title="Customer info"
      :active.sync="popupConfig.isOpen"
      fullscreen
    >
      <vs-tabs :color="colorx" class="customer-popup-content bg-white">
        <vs-tab @click="colorx = 'primary'" label="Profile" class="activeChild">
          <div class="con-tab-ejemplo customer">
            <!-- <h1 class="mb-6">Go Check-In Message Setting</h1>
            {{popupData}}-->
            <vs-update-customer
              :activeCustomer="activeCustomer"
              :key="activeCustomer.id"
              @ClosePopup="closePopup"
              :currentPage="currentPage"
              :itemsPerPage="itemsPerPage"
              :search="search"
              :filter="filter"
              :isFromCheckout="isFromCheckout"
              :checkoutFilter="checkoutFilter"
              :isPasscodeApprove="passcodeApprove"
              :isFromStaffRating="isFromStaffRating"
              :isFromReview="isFromReview"
              :isFromCalling="isFromCalling"
            ></vs-update-customer>
          </div>
        </vs-tab>

        <vs-tab @click="colorx = 'primary'" label="History">
          <div class="con-tab-ejemplo history">
            <!-- <h1 class="mb-4">Google Reply Review Setting</h1> -->
            <!-- {{customerHistory}} -->
            <vs-customer-history :activeCustomer="activeCustomer" :key="activeCustomer.id"></vs-customer-history>
          </div>
        </vs-tab>

        <vs-tab @click="colorx = 'primary'" label="Group">
          <div class="con-tab-ejemplo history">
            <vs-update-customer-group
              :activeCustomer="activeCustomer"
              :checkoutFilter="checkoutFilter"
              @UpdateCustomerGroup="updateCustomerGroup"
              :key="activeCustomer.id"
              :currentPage="currentPage"
              :itemsPerPage="itemsPerPage"
            ></vs-update-customer-group>
          </div>
        </vs-tab>
      </vs-tabs>
    </vs-popup>
    <vs-prompt
      @cancel="cancelAlert"
      @accept="acceptAlert"
      :active.sync="activePrompt"
      type="confirm"
      title="Passcode"
    >
      <div class="con-exemple-prompt">
        Enter the security code
        <vs-input
          placeholder="Code"
          v-model="passcode"
          type="password"
          class="passcode-input w-full"
          @keyup.enter="acceptAlert"
          @input="validate"
        />
      </div>
    </vs-prompt>
  </div>
</template>
<script>
import * as md5 from "md5";

export default {
  name: "customer-popup-content",
  props: {
    popupConfig: {
      type: Object,
      required: true,
    },
    activeCustomer: {
      type: Object,
      required: true,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    itemsPerPage: {
      type: Number,
      default: 10,
    },
    search: {
      type: String,
    },
    filter: {
      type: Object,
    },
    isFromCheckout: {
      type: Boolean,
      default: false,
    },
    isFromStaffRating: {
      type: Boolean,
      default: false
    },
    checkoutFilter: {
      type: Object,
      default: null
    },
    isFromReview: {
      type: Boolean,
      default: false
    },
    isFromCalling: {
      type: Boolean,
      default: false
    },
    // pageInfo: {
    //     type: Object,
    //     required: true
    // }
    // customerInfo: {
    //     type: Object,
    //     required: true
    // },
    // customerHistory: {
    //     type: Object,
    //     required: true
    // }
  },
  data() {
    return {
      colorx: "primary",
      activePrompt: false,
      passcodeApprove: false,
      passcode: "",
    };
  },
  watch: {
    popupConfig: {
      immediate: true,
      deep: true,
      handler() {
        if (this.popupConfig.isOpen) {
          // const scrollY = document.body.style.top;
          document.body.classList.add("overflow-hidden");
          // document.body.style.overflow = "hidden";
          document.body.style.position = "";
          document.body.style.top = "";
          window.scrollTo(0, parseInt(scrollY || "0") * -1);
        } else {
          document.body.classList.remove("overflow-hidden");
          // document.body.style.overflow = "visible";
        }
      },
    },
    isFromCheckout: {
      immediate: true,
      deep: true,
      handler() {
        if (
          this.isFromCheckout == true &&
          this.config.passcode_active == true
        ) {
          let expired = localStorage.getItem("passcode_checkout_expired");
          let enter_time = localStorage.getItem("passcode_checkout_enter");
          if (expired == null || enter_time == null) {
            this.activePrompt = true;
            return;
          }
          if (
            parseInt(enter_time) + parseInt(expired) <
            Math.floor(Date.now() / 1000)
          ) {
            this.activePrompt = true;
            return;
          }
          this.passcodeApprove = true;
        } else {
          this.passcodeApprove = true;
        }
      },
    },
  },
  computed: {
    config() {
      return this.$store.getters["auth/config"];
    },
  },
  methods: {
    updateCustomerGroup() {
      this.$emit("UpdateCustomerGroup");
    },
    closePopup() {
      this.$emit("ClosePopup");
    },
    acceptAlert() {
      if (this.config.passcode !== undefined) {
        if (md5(this.passcode + "GCI2020") == this.config.passcode) {
          this.activePrompt = false;
          localStorage.setItem(
            "passcode_checkout_enter",
            Math.floor(Date.now() / 1000)
          );
          localStorage.setItem("passcode_checkout_expired", 300);
          this.passcodeApprove = true;
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Authentication succesfully!",
          });
        }
        // else if (this.passcode == "2903") {
        //   this.activePrompt = false;
        //   localStorage.setItem(
        //     "passcode_checkout_enter",
        //     Math.floor(Date.now() / 1000)
        //   );
        //   localStorage.setItem("passcode_checkout_expired", 300);
        //   this.$vs.notify({
        //     color: "success",
        //     title: "Success",
        //     text: "Authentication succesfully!",
        //   });
        // }
        else {
          this.activePrompt = true;
          this.$vs.notify({
            color: "danger",
            title: "Failed",
            text: "Authentication failed!",
          });
        }
      } else {
        this.passcodeApprove = true;
        localStorage.setItem(
          "passcode_checkout_enter",
          Math.floor(Date.now() / 1000)
        );
        localStorage.setItem("passcode_checkout_expired", 300);
        this.$vs.notify({
          color: "success",
          title: "Success",
          text: "Authentication succesfully!",
        });
      }
    },
    cancelAlert() {
      this.activePrompt = false;
    },
    validate(value) {
      if (isNaN(value)) {
        this.passcode = this.passcode.slice(0, -1);
        return;
      }
      if (value.length > 4) {
        this.passcode = this.passcode.substr(0, 4);
      }
    },
  },
};
</script>